<footer class="footer section-outset-t pt-6 section-inset-y">
  <h2 class="sr-only">Footer</h2>
  <div class="container">
    <div class="row">
      <figure *ngIf="storefront?.logoFooter" class="col-md-3 mb-4 mb-lg-3 pt-md-1">
        <a [routerLink]="['/']" class="d-block">
          <img class="footer__logo" [src]="storefront?.logoFooter" alt="Kado Design" />
        </a>
      </figure>
      <div class="col-12 col-md-5 col-lg-4 mb-4 mb-lg-3 pt-md-1" *ngIf="socials.length">
        <h2 class="mb-3 newsletter-subscription__title">
          <span>{{ 'volg-onze-social-media-titel' | fromDictionary }}</span>
        </h2>
        <ul class="social-list">
          <li class="social-list__item" *ngFor="let item of socials; trackBy: trackById">
            <fstr-link
              [cssClasses]="'chip chip--light chip--lg '"
              [button]="{ text: '', url: item.url ? item.url : '' }"
              [showText]="false"
            >
              <app-icon class="icon-secondary icon-sm" [anchor]="item.icon || ''"></app-icon>
            </fstr-link>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-4 col-lg-4 align-self-center mt-2 ms-auto">
        <ng-content select="[footer-newsletter]"></ng-content>
      </div>
    </div>

    <div class="row footer__row" [class.has--odd-menu]="hasBigMenu">
      <nav class="nav mb-4 mb-lg-5 footer__row__contact col-12 col-lg-3">
        <h2 class="mb-0">
          <span class="nav__title">Contact</span>
        </h2>
        <ul class="nav__list row text-max-width-xxs">
          <li class="nav__list__item">
            <span class="nav__list__item__text">{{ 'kadodesign-openingstijden' | fromDictionary }}</span>
          </li>
          <li class="nav__list__item">
            <span class="nav__list__item__link link-underline-opacity-0" [innerHTML]="'kadodesign-telefoonnummer' | fromDictionary"></span>
          </li>
          <li class="nav__list__item">
            <span class="nav__list__item__link link-underline-opacity-0" [innerHTML]="'kadodesign-emailadres' | fromDictionary"></span>
          </li>
          <li class="nav__list__item">
            <span class="nav__list__item__link link-underline-opacity-0" [innerHTML]="'footer-showroom-url' | fromDictionary"></span>
          </li>
        </ul>
      </nav>

      <nav
        class="nav mb-4 mb-lg-5"
        [ngClass]="getColumnClasses(footerList.menuItems.length || 0)"
        *ngFor="let footerList of menu | ofMenuType: 'MenuItem'; trackBy: trackById"
      >
        <div class="nav__inner">
          <h2 class="mb-0">
            <a
              class="nav__title"
              *ngIf="footerList.url !== '#'"
              [routerLink]="footerList.url"
              [routerLinkActive]="'is--current'"
              [routerLinkActiveOptions]="{ exact: footerList.url === '/' }"
            >
              {{ footerList.title }}
            </a>
            <span class="nav__title" *ngIf="footerList.url === '#'">
              {{ footerList.title }}
            </span>
          </h2>
          <ul class="nav__list row">
            <li
              class="nav__list__item"
              [ngClass]="getColumnClassesInside(footerList.menuItems.length)"
              *ngFor="let item of footerList.menuItems | ofMenuType: 'MenuItem'"
            >
              <a
                *ngIf="item.routerLink?.length"
                class="nav__list__item__link"
                [routerLink]="item.routerLink"
                [routerLinkActive]="'is--current'"
                [routerLinkActiveOptions]="{ exact: item.url === '/' }"
              >
                {{ item.title }}
              </a>
              <a *ngIf="!item.routerLink?.length" class="nav__list__item__link" [href]="item.url" target="_blank">
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <!-- Email form here! -->
    </div>

    <div class="footer__meta">
      <div class="d-flex flex-column align-items-start">
        <ul class="meta-nav">
          <li class="meta-nav__item type-body-xs" *ngFor="let item of metaList">
            <a [routerLink]="item.url" [routerLinkActive]="'is--current'">{{ item.title }}</a>
          </li>
          <li class="meta-nav__item type-body-xs">
            <button (click)="openCookie()">{{ 'cookie-footer-link-tekst' | fromDictionary }}</button>
          </li>
        </ul>
        <span class="d-block mt-2 type-body-xs">&copy; {{ currentYear }} {{ 'footer-copy-tekst' | fromDictionary }}</span>
      </div>

      <ul class="payment-methods">
        <li
          class="payment-methods__item"
          *ngFor="let item of ['paypal', 'ideal', 'mastercard', 'apple-pay', 'google-pay', 'sofort', 'visa']"
        >
          <img [src]="(item + '-logo-afbeelding-url' | fromDictionary) + '?width=200&trim.treshold=80'" [alt]="item" />
        </li>
      </ul>
    </div>
  </div>
</footer>
